import { useEffect, useState } from "react";

const DRAW_DATE = new Date("2027-01-24T18:00:00");

function calc() {
  const diff = DRAW_DATE - new Date();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    minutes: Math.floor((diff / 60000) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
}

export const Countdown = ({ compact = false }) => {
  const [t, setT] = useState(calc());
  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
  }, []);

  const units = [
    { label: "Days", value: t.days },
    { label: "Hours", value: t.hours },
    { label: "Minutes", value: t.minutes },
    { label: "Seconds", value: t.seconds },
  ];

  return (
    <div className="flex gap-3 sm:gap-4" data-testid="countdown-timer">
      {units.map((u) => (
        <div
          key={u.label}
          className={`flex flex-col items-center justify-center rounded-lg border border-[#E2D9C8] bg-white/90 backdrop-blur ${
            compact ? "w-16 h-16" : "w-[72px] h-[76px] sm:w-24 sm:h-24"
          }`}
        >
          <span className={`font-mono font-bold text-[#9E1B1B] ${compact ? "text-xl" : "text-2xl sm:text-4xl"}`}>
            {String(u.value).padStart(2, "0")}
          </span>
          <span className="text-[10px] sm:text-xs tracking-[0.15em] uppercase text-[#4A4A4A]">{u.label}</span>
        </div>
      ))}
    </div>
  );
};

export default Countdown;
